/**
 * @fileoverview DELETE handler for the "/companies/:company_id/developers/:developer_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdDevelopersDeveloperIdCacheKeys } from "./constants";
import type {
  DeleteCompaniesCompanyIdDevelopersDeveloperIdProps,
  CompaniesCompanyIdDevelopersDeveloperIdDeletionResult,
} from "./types";

export const deleteCompaniesCompanyIdDevelopersDeveloperId = reactQueryMutationAdapter(
  companiesCompanyIdDevelopersDeveloperIdCacheKeys,
  (
    props: DeleteCompaniesCompanyIdDevelopersDeveloperIdProps
  ): Promise<CompaniesCompanyIdDevelopersDeveloperIdDeletionResult> => {
    // manipulate props here as needed {  }

    return fetch(`/companies/${props.companyId}/developers/${props.developerId}`, "DELETE");
  }
);
